module.exports = __webpack_public_path__ + "img/health.2f0994ae.svg";